const MASS_PAYMENTS_GETTERS = {
  loading: 'massPayments/loading',
  actionLoading: 'massPayments/actionLoading',
  items: 'massPayments/items',
  sorting: 'massPayments/sort',
  search: 'massPayments/search',
  formData: 'detailMassPayments/formData',
  termsAccepted: 'massPayments/termsAccepted',
}

const MASS_PAYMENTS_DISPATCHERS = {
  createMassPayment: 'massPayments/createMassPayment',
  onSearch: 'massPayments/onSearch',
  goToLoadDetail: 'massPayments/goToLoadDetail',
  getMassPayments: 'massPayments/getMassPayments',
  resetStore: 'massPayments/resetStore',
  changePage: 'massPayments/changePage',
  onSelectSort: 'massPayments/onSelectSort',
  deleteMassPayments: 'massPayments/deleteMassPayments',
  updateMassPayment: 'detailMassPayments/updateMassPayment',
  goToDownloadTableRow: 'detailMassPayments/goToDownloadTableRow',
  resetSearch: 'massPayments/resetSearch',
  getTermsStatus: 'massPayments/getTermsStatus',
  acceptTerms: 'massPayments/acceptTerms',
}

export { MASS_PAYMENTS_GETTERS, MASS_PAYMENTS_DISPATCHERS }
